
import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import { Popup, Toast, Tab, Tabs, List } from 'vant';
import { getVoteList } from '../api';
Vue.use(Popup);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Toast);
Vue.use(List);
@Component({
  components: {
    SearchBar,
  },
})
export default class Home extends Vue {
  tabData: any = ['一等奖','二等奖','三等奖','优秀奖'];
  tabDataTwo: any = ['小学组','初中组','高中/职高组','大学/高职组'];
  loading = false;
  finished = false;
  listStatus = true;
  showlist = true;
  keyword: any = '';
  list: any = [];
  page = 1;
  number = 3;
  awards = 1;
  groups = 1;
  changeTab(e:any){
    this.awards = e + 1;
    this.reset();
    this.showlist = false;
    setTimeout(() => {
      this.showlist = true;
    },50)
  }

  changeTabTwo(e:any){
    this.groups = e + 1;
    this.reset();
    this.showlist = false;
    setTimeout(() => {
      this.showlist = true;
    },50)
  }

  async onGetVoteList() {
    console.log(this.keyword);
    if (this.finished) {
      return console.log('no more data');
    }
    this.loading = true;
    let ret: any;
    ret = await getVoteList(this.page, this.number, this.awards, this.groups, this.keyword);
    this.loading = false;
    if (ret.data && ret.data.length) {
      this.list = [...this.list, ...ret.data];
      this.page++;
    } else {
      this.finished = true;
    }
  }

  onNavToDetail(id: number) {
    this.$router.push(`detail?id=${id}`);
  }

  onClear() {
    this.reset();
    this.showlist = false;
    setTimeout(() => {
      this.showlist = true;
    },50)
  }

  onSearch() {
    this.reset();
    this.showlist = false;
    setTimeout(() => {
      this.showlist = true;
    },50)
  }

  reset() {
    this.loading = false;
    this.page = 1;
    this.list = [];
    this.finished = false;
  }
}
